import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { localDateRange } from "@faire/web--source/common/localization/localDateRange";
import { IShipWindow } from "@faire/web-api--source/indigofair/data/IShipWindow";
import addDays from "date-fns/addDays";
import differenceInDays from "date-fns/differenceInDays";
import { DEFAULT_LOCALE } from "./consts/DEFAULT_LOCALE";
import { FaireDate } from "./FaireDate";
import { intlDate, intlDateFormatOptions } from "./localization/date-fns/intlDate";
import { LocalizationStore } from "./localization/LocalizationStore";
import { MutableFaireDateRange } from "./MutableFaireDateRange";
import { isNotUndefined } from "./typescriptUtils";
/**
 * @deprecated use localFormat
 */ export var PresetDateFormat;
(function(PresetDateFormat) {
    /**
     * single: MMM d
     * within month: MMM d–d
     * across month: MMM d–MMM d
     * across year: MMM d, yyyy–MMM d, yyyy
     */ PresetDateFormat[PresetDateFormat["ABBREVIATED_MMM_D"] = 0] = "ABBREVIATED_MMM_D";
    /**
     * single: MMM d, yyyy
     * within month: MMM d–d, yyyy
     * across month: MMM d–MMM d, yyyy
     * across year: MMM d, yyyy–MMM d, yyyy
     */ PresetDateFormat[PresetDateFormat["ABBREVIATED_MMM_D_YYYY"] = 1] = "ABBREVIATED_MMM_D_YYYY";
    /**
     * single: MMM yyyy
     * within month: MMM yyyy
     * across month: MMM–MMM yyyy
     * across year: MMM yyyy–MMM yyyy
     */ PresetDateFormat[PresetDateFormat["ABBREVIATED_MMM_YYYY"] = 2] = "ABBREVIATED_MMM_YYYY";
    /**
     * single: MMMM d
     * within month: MMMM d–d
     * across month: MMMM d–MMMM d
     * across year: MMMM d, yyyy–MMMM d, yyyy
     */ PresetDateFormat[PresetDateFormat["MMMM_D"] = 3] = "MMMM_D";
    /**
     * single: MMMM d, yyyy
     * within month: MMMM d–d, yyyy
     * across month: MMMM d–MMMM d, yyyy
     * across year: MMMM d, yyyy–MMMM d, yyyy
     */ PresetDateFormat[PresetDateFormat["MMMM_D_YYYY"] = 4] = "MMMM_D_YYYY";
})(PresetDateFormat || (PresetDateFormat = {}));
var _obj;
var PRESET_DATE_FORMATS = (_obj = {}, _define_property(_obj, PresetDateFormat.ABBREVIATED_MMM_D, {
    month: "short",
    day: "numeric"
}), _define_property(_obj, PresetDateFormat.ABBREVIATED_MMM_YYYY, {
    year: "numeric",
    month: "short"
}), _define_property(_obj, PresetDateFormat.ABBREVIATED_MMM_D_YYYY, {
    year: "numeric",
    month: "short",
    day: "numeric"
}), _define_property(_obj, PresetDateFormat.MMMM_D, {
    month: "long",
    day: "numeric"
}), _define_property(_obj, PresetDateFormat.MMMM_D_YYYY, {
    year: "numeric",
    month: "long",
    day: "numeric"
}), _obj);
export var FaireDateRange = /*#__PURE__*/ function() {
    "use strict";
    function FaireDateRange(startDate, endDate) {
        var _this = this;
        var _this1 = this;
        _class_call_check(this, FaireDateRange);
        this.startDate = startDate;
        this.endDate = endDate;
        this.toMutable = function() {
            return new MutableFaireDateRange(_this.startDate, _this.endDate);
        };
        /**
         * @deprecated use localFormat
         */ this.formatPresetDateRange = function(presetDateFormat) {
            var _PRESET_DATE_FORMATS_presetDateFormat;
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            var opts = (_PRESET_DATE_FORMATS_presetDateFormat = PRESET_DATE_FORMATS[presetDateFormat]) !== null && _PRESET_DATE_FORMATS_presetDateFormat !== void 0 ? _PRESET_DATE_FORMATS_presetDateFormat : {
                year: "numeric",
                month: "long",
                day: "numeric"
            };
            var localizeString = LocalizationStore.get().intl.formatDateTimeRange(_this.startDate.localDateObject, _this.endDate.localDateObject, opts);
            return LocalizationStore.get().locale === DEFAULT_LOCALE ? localizeString.replace(" – ", "–") : localizeString;
        };
        this.localFormat = function(formatters) {
            return localDateRange(_this.startDate.valueOf(), _this.endDate.valueOf(), formatters);
        };
        /**
         * @deprecated use FaireDateRange.localFormat
         * Default format is 'MMMM d' if nothing provided.
         */ this.format = function() {
            var faireDateRangeFormat = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, locale = arguments.length > 1 ? arguments[1] : void 0;
            if (!_this1.startDate) {
                return;
            }
            if (isNotUndefined(faireDateRangeFormat.presetDateFormat)) {
                return _this1.formatPresetDateRange(faireDateRangeFormat.presetDateFormat);
            }
            var _faireDateRangeFormat_dateFormat = faireDateRangeFormat.dateFormat, dateFormat = _faireDateRangeFormat_dateFormat === void 0 ? "MMMM d" : _faireDateRangeFormat_dateFormat, _faireDateRangeFormat_multiDayFormat = faireDateRangeFormat.multiDayFormat, multiDayFormat = _faireDateRangeFormat_multiDayFormat === void 0 ? dateFormat : _faireDateRangeFormat_multiDayFormat;
            // single day date range
            if (_this1.startDate.valueOf() === _this1.endDate.valueOf()) {
                return "".concat(intlDate(_this1.startDate.localDateObject, dateFormat, locale));
            }
            var localizeString = LocalizationStore.get().intl.formatDateTimeRange(_this1.startDate.localDateObject, _this1.endDate.localDateObject, intlDateFormatOptions(multiDayFormat));
            return LocalizationStore.get().locale === DEFAULT_LOCALE ? localizeString.replace(" – ", "–") : localizeString;
        };
        this.toShipWindow = function() {
            return IShipWindow.build({
                start_date: _this.startDate.normalizedUtcTimestamp,
                window_days: _this.windowDays
            });
        };
    }
    _create_class(FaireDateRange, [
        {
            key: "windowDays",
            get: function get() {
                return differenceInDays(this.endDate.localDateObject, this.startDate.localDateObject);
            }
        }
    ]);
    return FaireDateRange;
}();
FaireDateRange.fromShipWindow = function(shipWindow) {
    if (shipWindow === undefined) {
        return undefined;
    }
    return FaireDateRange.create(shipWindow.start_date, shipWindow.window_days);
};
FaireDateRange.create = function(startDateMillis) {
    var days = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (startDateMillis == null) {
        return undefined;
    }
    var startDate = new Date(startDateMillis);
    var endDate = addDays(startDate, days);
    return new FaireDateRange(FaireDate.fromLocalDateObject(startDate), FaireDate.fromLocalDateObject(endDate));
};
FaireDateRange.isEqual = function(a, b) {
    return compareFaireDateRanges(a, b) === 0;
};
/**
 * Compares two date ranges.
 *
 * Range A is consider smaller than range B if A start date is
 * smaller than B start date, or, in the case of same start dates, A end date is
 * smaller than B end date. If both start and end date are the same, the
 * A and B are consider equal. Otherwise, B is considered greater than A.
 * Undefined range is treated as the smallest possible value, and hence
 * deemed smaller than all other ranges (two undefined ranges are
 * considered equal.
 *
 * Returns a negative value if first range is less than second range,
 * zero if they're equal and a positive value otherwise.
 */ export var compareFaireDateRanges = function(a, b) {
    var _a_startDate_normalizedUtcTimestamp;
    var aStartTimestamp = (_a_startDate_normalizedUtcTimestamp = a === null || a === void 0 ? void 0 : a.startDate.normalizedUtcTimestamp) !== null && _a_startDate_normalizedUtcTimestamp !== void 0 ? _a_startDate_normalizedUtcTimestamp : 0;
    var _b_startDate_normalizedUtcTimestamp;
    var bStartTimestamp = (_b_startDate_normalizedUtcTimestamp = b === null || b === void 0 ? void 0 : b.startDate.normalizedUtcTimestamp) !== null && _b_startDate_normalizedUtcTimestamp !== void 0 ? _b_startDate_normalizedUtcTimestamp : 0;
    var _a_endDate_normalizedUtcTimestamp, _b_endDate_normalizedUtcTimestamp;
    return aStartTimestamp === bStartTimestamp ? ((_a_endDate_normalizedUtcTimestamp = a === null || a === void 0 ? void 0 : a.endDate.normalizedUtcTimestamp) !== null && _a_endDate_normalizedUtcTimestamp !== void 0 ? _a_endDate_normalizedUtcTimestamp : 0) - ((_b_endDate_normalizedUtcTimestamp = b === null || b === void 0 ? void 0 : b.endDate.normalizedUtcTimestamp) !== null && _b_endDate_normalizedUtcTimestamp !== void 0 ? _b_endDate_normalizedUtcTimestamp : 0) : aStartTimestamp - bStartTimestamp;
};
